import { render, staticRenderFns } from "./OriginatorDetails.vue?vue&type=template&id=601a63bd&scoped=true"
import script from "./OriginatorDetails.vue?vue&type=script&lang=js"
export * from "./OriginatorDetails.vue?vue&type=script&lang=js"
import style0 from "./OriginatorDetails.vue?vue&type=style&index=0&id=601a63bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601a63bd",
  null
  
)

export default component.exports